export const FETCH_GROUP_DETAILS = 'playerGroups/FETCH_GROUP_DETAILS';
export const FETCH_GROUP_DETAILS_FAILURE = 'playerGroups/FETCH_GROUP_DETAILS_FAILURE';
export const FETCH_GROUP_DETAILS_SUCCESS = 'playerGroups/FETCH_GROUP_DETAILS_SUCCESS';

export const FETCH_GROUP_BALANCE = 'balance/FETCH_ALL_TRANSACTIONS';
export const FETCH_GROUP_BALANCE_SUCCESS = 'balance/FETCH_ALL_TRANSACTIONS_SUCCESS';
export const FETCH_GROUP_BALANCE_FAILURE = 'balance/FETCH_ALL_TRANSACTIONS_FAILURE';

export const FETCH_ALL_GAMERUNNERS = 'games/FETCH_ALL_GAMERUNNERS';
export const FETCH_ALL_GAMERUNNERS_SUCCESS = 'games/FETCH_ALL_GAMERUNNERS_SUCCESS';
export const FETCH_ALL_GAMERUNNERS_FAILURE = 'games/FETCH_ALL_GAMERUNNERS_FAILURE';
